document.addEventListener('DOMContentLoaded', function () {
    updateCommentTimes();
    setInterval(updateCommentTimes, 60000);
});

function updateCommentTimes() {
    const comments = document.querySelectorAll('.comment');

    comments.forEach(comment => {
        const publishDateMeta = comment.querySelector('meta[itemprop="datePublished"]');
        if (!publishDateMeta) return;

        const publishDate = new Date(publishDateMeta.getAttribute('content'));
        const timeSinceElement = comment.querySelector('.comment-time-since');

        if (timeSinceElement && new Date() - publishDate < 2 * 24 * 60 * 60 * 1000) {
            timeSinceElement.textContent = formatTimeSince(publishDate);
        }
    });
}

function formatTimeSince(date) {
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    let timeSince = '';

    if (diffInSeconds < 60) {
        timeSince = 'Just now';
    } else if (diffInSeconds < 3600) {
        const mins = Math.floor(diffInSeconds / 60);
        timeSince = `${mins} minute${mins > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        timeSince = `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else {
        const days = Math.floor(diffInSeconds / 86400);
        timeSince = `${days} day${days > 1 ? 's' : ''} ago`;
    }

    return timeSince;
}
